// Serialize rows (array of objects) to a CSV string using the given header order.
export function toCSV(headers, rows) {
  const esc = (v) => {
    const s = v === undefined || v === null ? '' : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [headers.join(',')];
  rows.forEach((row) => lines.push(headers.map((h) => esc(row[h])).join(',')));
  return lines.join('\r\n');
}

// Trigger a browser download of `text` as a file named `filename`.
export function downloadFile(text, filename, mime = 'text/csv;charset=utf-8;') {
  const blob = new Blob(['﻿' + text], { type: mime }); // BOM so Excel keeps UTF-8
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

// Minimal, dependency-free CSV parser.
// Handles quoted fields, commas/newlines inside quotes, escaped double-quotes
// ("" -> "), CRLF line endings and a leading UTF-8 BOM.
export function parseCSV(text) {
  if (!text) return { headers: [], rows: [] };
  const src = text.replace(/^﻿/, ''); // strip BOM
  const records = [];
  let field = '';
  let record = [];
  let inQuotes = false;

  for (let i = 0; i < src.length; i++) {
    const c = src[i];
    if (inQuotes) {
      if (c === '"') {
        if (src[i + 1] === '"') { field += '"'; i++; } // escaped quote
        else inQuotes = false;
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ',') {
      record.push(field); field = '';
    } else if (c === '\n' || c === '\r') {
      if (c === '\r' && src[i + 1] === '\n') i++; // consume CRLF pair
      record.push(field); field = '';
      records.push(record); record = [];
    } else {
      field += c;
    }
  }
  // flush trailing field/record (file may not end with newline)
  if (field !== '' || record.length > 0) { record.push(field); records.push(record); }

  // drop fully-empty trailing rows
  const nonEmpty = records.filter((r) => r.some((v) => String(v).trim() !== ''));
  if (nonEmpty.length === 0) return { headers: [], rows: [] };

  const headers = nonEmpty[0].map((h) => String(h).trim());
  const rows = nonEmpty.slice(1).map((cells) => {
    const obj = {};
    headers.forEach((h, idx) => { obj[h] = cells[idx] !== undefined ? String(cells[idx]).trim() : ''; });
    return obj;
  });
  return { headers, rows };
}
